import React from 'react';
import { Modal } from 'antd';

interface ConfirmDeleteModalProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  title: React.ReactNode;
  description: React.ReactNode;
  okText?: string;
  cancelText?: string;
  okButtonProps?: any;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  open,
  onOk,
  onCancel,
  title,
  description,
  okText = 'Delete',
  cancelText = 'Cancel',
  okButtonProps = { danger: true },
}) => (
  <Modal
    title={title}
    open={open}
    onOk={onOk}
    onCancel={onCancel}
    okText={okText}
    cancelText={cancelText}
    okButtonProps={okButtonProps}
  >
    {description}
  </Modal>
);

export default ConfirmDeleteModal; 